import { CrudBuilderConfig } from '../../components/crudbuilder/models/crud-builder-config';
import ListFormatter from '../../helpers/list-formatter';
import Formatter from '../../helpers/formatter';
import { createVehicle, Vehicle } from '../../state/vehicles';
import { FieldConfig } from '../../components/crudbuilder/models/field-config';
import { Person } from '../../state/people';

export class VehiclesCrudBuilderConfigClass extends CrudBuilderConfig {
  singular  = 'Vehicle';
  plural    = 'Vehicles';
  modelAlias = 'vehicle';
  path      = 'vehicles';
  fields    = [
    new FieldConfig('type_configuration_id', 'vehicle_type', 'Vehicle'),
    new FieldConfig('person_id', 'person', 'Person'),
    new FieldConfig('description', 'text', 'Description'),
    'model',
    'make',
    'registration',
    new FieldConfig('km', 'number', 'Mileage'),
    new FieldConfig('current_value', 'money'),
    new FieldConfig('purchase_price', 'money'),
    new FieldConfig('vehicle_tax', 'money'),
    new FieldConfig('insurance', 'money'),
    new FieldConfig('specialties', 'text', 'Specialties'),
  ];
  readFields = [
    new FieldConfig('description', 'text', 'Description'),
    new FieldConfig('person_id', 'person', 'Person'),
    'model',
    new FieldConfig('type_configuration_id', 'vehicle_type'),
    'make',
    'registration',
    new FieldConfig('insurance', 'money'),
    new FieldConfig('current_value', 'money'),
    new FieldConfig('purchase_price', 'money'),
    new FieldConfig('vehicle_tax', 'money'),
    new FieldConfig('km', 'number', 'Mileage'),
    new FieldConfig('specialties', 'text', 'Specialties'),
  ];
  listView(model: Vehicle) {
    let type = '';
    if (model['type']) {
      type = model.type.name;
    }

    const view = new ListFormatter()
      .fHead('Model', model.model)
      .fHead('Type', type)
      .fSub('Purchase Price', Formatter.formatMoney(model.purchase_price))
      .fSub2('Mileage', Formatter.formatNumber(model.km) + 'km')
    ;
    return view.toString();
  }
  getModel() {
    return createVehicle({});
  }
  getReadTitle(model: Vehicle) {
    return model.model;
  }
  editPreprocess(model: Vehicle) {
    if (!model) {
      return;
    }
    const newModel = {...model};
    newModel.type_configuration_id = model.type.id;
    return newModel;
  }
  runBeforeSavingOnAddView(model: Vehicle, states) {
    return model;
  }
}

export const VehiclesCrudBuilderConfig = new VehiclesCrudBuilderConfigClass();
